import * as wf from "client-api-workflow";
import { useQuery } from "react-query";
const useDelegateUsers = (id?: string) => {
  return useQuery(
    JSON.stringify(["wf-delegate-users", id]),
    () => {
      return wf.getDelegateUsers(id || "");
    },
    {
      enabled: !!id,
      cacheTime: 1 * 1000,
    }
  );
};

export default useDelegateUsers;
